var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { action, observable } from "mobx";
import { RecaptchaEndpoints } from "../endpoints/recaptcha.endpoints";
import { isDevelopment, SHOULD_LOG } from "../env";
import { sortRandomly } from "./array.utils";
import { reportError } from "./errors.utils";
import { loadScript } from "./loadScript.util";
import { getRandomInteger } from "./random.utils";
var anyWindow = window;
var apiKey = isDevelopment ? '6LcvaSIfAAAAAIXjFxez0YcL4tm_-6apjCJTnaQ4' : '6LfrSSIbAAAAALgKs-fPlZDoZAD2vd0XF87L9_81';
var protectedHostnames = __spreadArray(__spreadArray([], isDevelopment ? ['localhost'] : [], true), [
    // 'turn2me-v2.test',
    'wp.turn2me.ie',
    'turn2me.ie',
    'turn2me.eu.ngrok.io',
], false);
var privateState = observable({
    currentHostnameIsProtected: protectedHostnames.includes(window.location.hostname),
    shouldByPassRecaptcha: false,
});
export var checkErrorForRecaptchaFailure = action(function (error) {
    var string = JSON.stringify(error);
    if (string.includes('Using fallback')) {
        privateState.shouldByPassRecaptcha = true;
        SHOULD_LOG() && console.log('Next submission will bypass recaptcha and use fallback');
    }
});
export var fallbackValidator = function (UI) { return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
    var a, b, sum, checkAnswer, actions;
    return __generator(this, function (_a) {
        a = getRandomInteger(1, 6);
        b = getRandomInteger(a, 9);
        sum = a + b;
        checkAnswer = function (value) {
            if (value === sum)
                resolve('FALLBACK_RECAPTCHA_PASSED');
            else
                reject('FALLBACK_RECAPTCHA_FAILED');
        };
        actions = sortRandomly([
            {
                buttonClass: "subtle",
                label: sum + '',
                action: function () { return checkAnswer(sum); },
            },
            {
                buttonClass: "subtle",
                label: Math.round(sum * 2.3) + '',
                action: function () { return checkAnswer(Math.round(sum * 2.3)); },
            },
            {
                buttonClass: "subtle",
                label: Math.round(sum / 1.5) + '',
                action: function () { return checkAnswer(Math.round(sum / 1.5)); },
            },
        ]);
        UI.DIALOG.present({
            heading: "Which number is the sum of " + a + " and " + b + "?",
            actions: actions,
        });
        return [2 /*return*/];
    });
}); }); };
var loadRecaptchaScript = function () {
    return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, loadScript("https://www.google.com/recaptcha/api.js?render=" + apiKey)];
                case 1:
                    _a.sent();
                    resolve("LOADED_GOOGLE_RECAPTCHA_SCRIPT");
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    reportError('Failed to load Google reCAPTCHA script. Using fallback.');
                    reject('Failed to load Google reCAPTCHA script. Please try again.');
                    return [2 /*return*/];
                case 3: return [2 /*return*/];
            }
        });
    }); });
};
loadRecaptchaScript();
export function asyncGetRecaptchaToken(action, UI, API) {
    var _this = this;
    if (action === void 0) { action = 'submit'; }
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var fallbackValidatorResult, e_2, hasRecaptcha, e_3, grecaptcha, timeout;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!privateState.currentHostnameIsProtected) {
                        SHOULD_LOG() && console.log('Current hostname is not protected by recaptcha.');
                        privateState.shouldByPassRecaptcha = true;
                    }
                    if (!privateState.shouldByPassRecaptcha) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fallbackValidator(UI)];
                case 2:
                    fallbackValidatorResult = _a.sent();
                    resolve(fallbackValidatorResult);
                    return [3 /*break*/, 5];
                case 3:
                    e_2 = _a.sent();
                    reject(e_2);
                    return [3 /*break*/, 5];
                case 4: return [2 /*return*/];
                case 5:
                    hasRecaptcha = anyWindow.grecaptcha;
                    if (!!hasRecaptcha) return [3 /*break*/, 9];
                    _a.label = 6;
                case 6:
                    _a.trys.push([6, 8, , 9]);
                    return [4 /*yield*/, loadRecaptchaScript()];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 9];
                case 8:
                    e_3 = _a.sent();
                    reject('Failed to load Google reCAPTCHA script. Using fallback.');
                    return [3 /*break*/, 9];
                case 9:
                    grecaptcha = anyWindow.grecaptcha;
                    if (!grecaptcha) {
                        reject('Failed to load Google reCAPTCHA script. Using fallback.');
                    }
                    SHOULD_LOG() && console.log('sending recaptcha request...');
                    try {
                        grecaptcha.ready(function () {
                            timeout = setTimeout(function () {
                                reject('Google reCAPTCHA timed out. Using fallback.');
                            }, 6180);
                            try {
                                grecaptcha.execute(apiKey, { action: action }).then(function (token) { return __awaiter(_this, void 0, void 0, function () {
                                    var url, payload, success, e_4;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                SHOULD_LOG() && console.log('Google reCAPTCHA token received.');
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([1, 3, , 4]);
                                                url = RecaptchaEndpoints.public.verify;
                                                payload = {
                                                    recaptchaToken: token
                                                };
                                                return [4 /*yield*/, API.postRaw(url, payload)];
                                            case 2:
                                                success = (_a.sent()).data.success;
                                                if (success) {
                                                    SHOULD_LOG() && console.log('Google reCAPTCHA request returns true.');
                                                    resolve(token);
                                                }
                                                else {
                                                    SHOULD_LOG() && console.log('Google reCAPTCHA request returns false.');
                                                    reject('Google reCAPTCHA failed.');
                                                }
                                                return [3 /*break*/, 4];
                                            case 3:
                                                e_4 = _a.sent();
                                                reject('Google reCAPTCHA failed.');
                                                return [3 /*break*/, 4];
                                            case 4:
                                                clearTimeout(timeout);
                                                return [2 /*return*/];
                                        }
                                    });
                                }); });
                            }
                            catch (e) {
                                reject(e);
                                clearTimeout(timeout);
                            }
                        });
                    }
                    catch (e) {
                        reject(e);
                        clearTimeout(timeout);
                    }
                    return [2 /*return*/];
            }
        });
    }); });
}
